import React from 'react';

// local dependencies
import { heartBeatPreloader as HeartBeatPreloader } from 'ui/views/generic/heartBeatPreloader';
import { progressLine as ProgressLine } from 'ui/views/generic/progressLine';
import { messageBus as MessageBus } from 'core/modules/message-bus';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';
import { PAGE_LEVEL_PRELOADER_TEMPLATES } from 'constants/common';

// default state
const DEFAULT_STATE = {
    template: null,
	showPreloader: false,
	opacity: 0.85
};

/**
 * @type {function}
 * @desc A Higher-Order-Component to enhance functionality of `Component`
 * @param {object} Component - A React component
 * @example
 * import { pageLevelPreloader, PageLevelPreloader } from 'modules/page-level-preloader';
 *
 * // create a component
 * const ComponentWithHOC = pageLevelPreloader( CustomView );
 */
const pageLevelPreloader = () => {
    class PageLevelPreloader extends React.Component {
        constructor( props ) {
            log.debug( 'PageLevelPreloader.constructor()' );

			super( props );

			this.__bind();

            this.state = DEFAULT_STATE;
        }

        __bind() {
			log.debug( 'PageLevelPreloader.__bind()' );

            this.handleHidePreloader = this.handleHidePreloader.bind( this );
            this.handleShowPreloader = this.handleShowPreloader.bind( this );
        }

        /**
         * @desc When component mounts, add MessageBus event listeners.
         */
        componentDidMount() {
            log.debug( 'PageLevelPreloader.componentWillMount()' );

            MessageBus.on( MESSAGE_BUS_EVENTS.SHOW_PAGE_LEVEL_PRELOADER, this.handleShowPreloader, this );
            MessageBus.on( MESSAGE_BUS_EVENTS.HIDE_PAGE_LEVEL_PRELOADER, this.handleHidePreloader, this );
        }

        /**
         * @desc When component unmounts, remove MessageBus event listeners.
         */
        componentWillUnmount() {
            log.debug( 'PageLevelPreloader.componentWillUnmount()' );

            MessageBus.off( MESSAGE_BUS_EVENTS.SHOW_PAGE_LEVEL_PRELOADER, this.handleShowPreloader, this );
            MessageBus.off( MESSAGE_BUS_EVENTS.HIDE_PAGE_LEVEL_PRELOADER, this.handleHidePreloader, this );
        }

        /**
         * @desc Set `showPreloader` state to `true`.
         */
        handleShowPreloader( template = null ) {
            log.debug( 'PageLevelPreloader.handleShowPreloader()' );

            if( ! this.state.showPreloader || this.state.template !== template ) {
                this.setState( {
                    showPreloader: true,
                    template,
                } );
            }
        }

        /**
         * @desc Set `showPreloader` state to `false`.
         */
        handleHidePreloader() {
            log.debug( 'PageLevelPreloader.handleHidePreloader()' );

            this.setState( {
                showPreloader: false,
                template: null,
			} );

        }

        /********************************************/

        render() {
			log.debug( 'PageLevelPreloader.render()' );

			if( this.state.showPreloader ) {

                // render progress line (nanobar) template
                if( this.state.template === PAGE_LEVEL_PRELOADER_TEMPLATES.NANOBAR ) {
                    return (
                        <div className='ui-page-level-preloader-nanobar' style={ { opacity: this.state.opacity } } >
                            <ProgressLine { ...this.props } />
                        </div>
                    );
                }

                /*--------*/
                
                // return default preloader (heartbeat)
                return (
					<div className='ui-page-level-preloader-default' style={ { opacity: this.state.opacity } } >
						<HeartBeatPreloader { ...this.props } />
					</div>
				);
			} else {
				return (
					null
				);
			}

        }
    }

    // set display name
    PageLevelPreloader.displayName = 'PageLevelPreloader';

    // default props
    PageLevelPreloader.defaultProps = {};

    // prop types
    PageLevelPreloader.propTypes = {};

    // return component
    return PageLevelPreloader;
};

// export HOC
export { pageLevelPreloader };

// export react component with default view
export const PageLevelPreloader = pageLevelPreloader();
